var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLightBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13209_5576)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#5D6A76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7104 15.3089L19.0827 21.603C18.1621 22.5179 17.6484 23.7345 17.6484 24.9998C17.6484 26.2651 18.1621 27.4817 19.0827 28.3967L25.7104 34.6908C26.1172 35.077 26.6689 35.2939 27.2442 35.2939C27.8194 35.2939 28.3711 35.077 28.7779 34.6908C29.1846 34.3046 29.4131 33.7808 29.4131 33.2346C29.4131 32.6884 29.1846 32.1646 28.7779 31.7784L22.1487 25.4843C22.0132 25.3556 21.937 25.1811 21.937 24.9991C21.937 24.8172 22.0132 24.6427 22.1487 24.514L28.7779 18.2212C29.1846 17.835 29.4131 17.3112 29.4131 16.7651C29.4131 16.2189 29.1846 15.6951 28.7779 15.3089C28.3711 14.9227 27.8194 14.7057 27.2442 14.7057C26.6689 14.7057 26.1172 14.9227 25.7104 15.3089Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13209_5576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLightBackground);
export default __webpack_public_path__ + "static/media/chevron-light-background.043945c683c18c3799c4c7aa17aca677.svg";
export { ForwardRef as ReactComponent };